export default "__VITE_ASSET__0246672b__"